var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dashboard-text"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "src": require("../../../assets/oa/approve-back.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeBack()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("OA设置")])]), _vm._v(" "), (!_vm.detailShow) ? _c('div', {
    staticClass: "dashboard-content"
  }, [_c('el-form', {
    staticStyle: {
      "position": "relative",
      "padding": "40px 0 10px 46px",
      "border-bottom": "1px solid #C1C1C1"
    },
    attrs: {
      "inline": true,
      "model": _vm.ruleForm
    }
  }, [_c('el-form-item', {
    staticClass: "items",
    attrs: {
      "label": "审批流名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入审批流名称",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.approval_process_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "approval_process_name", $$v)
      },
      expression: "ruleForm.approval_process_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "items",
    attrs: {
      "label": "关联流程"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择关联流程",
      "filterable": ""
    },
    model: {
      value: (_vm.ruleForm.approval_process_type),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "approval_process_type", $$v)
      },
      expression: "ruleForm.approval_process_type"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "items",
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入备注",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.remarks),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remarks", $$v)
      },
      expression: "ruleForm.remarks"
    }
  })], 1), _vm._v(" "), (_vm.tabIndex == 0) ? _c('el-form-item', [(_vm.num == 1) ? _c('el-button', {
    staticClass: "dashboard-button",
    on: {
      "click": function($event) {
        return _vm.Save()
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.num == 2) ? _c('el-button', {
    staticClass: "dashboard-button",
    on: {
      "click": function($event) {
        return _vm.Update()
      }
    }
  }, [_vm._v("修改")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "tab-wrap"
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tab",
      class: _vm.tabIndex == index ? 'tabClass' : '',
      style: (index == 0 ? 'border-left:none' : ''),
      on: {
        "click": function($event) {
          return _vm.tabClick(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item))]), _vm._v(" "), (index == 1) ? _c('img', {
      staticClass: "oa-add",
      attrs: {
        "src": require("../../../assets/oa/add.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.addClick()
        }
      }
    }) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-hr"
  })]), _vm._v(" "), (_vm.tabIndex == 1) ? _c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.ruleForm
    }
  }, _vm._l((_vm.nodeList), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_c('el-scrollbar', {
      ref: "myScrollbar",
      refInFor: true,
      staticClass: "scrollbar",
      staticStyle: {
        "height": "360px",
        "margin-right": "20px"
      },
      attrs: {
        "vertical": false
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_vm._l((item.conditionList), function(item1, index1) {
      return _c('div', {
        key: index1,
        staticStyle: {
          "border": "1px solid #F3F3F3",
          "margin-right": "15px"
        }
      }, [_c('div', {
        staticClass: "oa-title"
      }, [_c('div', [_c('span', [_vm._v("节点")]), _vm._v(" "), _c('el-input', {
        staticStyle: {
          "width": "60px"
        },
        attrs: {
          "size": "small",
          "clearable": ""
        },
        model: {
          value: (item1.node),
          callback: function($$v) {
            _vm.$set(item1, "node", $$v)
          },
          expression: "item1.node"
        }
      })], 1), _vm._v(" "), _c('img', {
        staticClass: "oa-delete",
        attrs: {
          "src": require("../../../assets/oa/delete.png"),
          "alt": ""
        },
        on: {
          "click": function($event) {
            return _vm.delTwoClick(index, index1)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "oa-infor"
      }, [_c('div', {
        staticClass: "infor-left"
      }, [_c('el-radio-group', {
        staticStyle: {
          "margin": "24px 0"
        },
        model: {
          value: (item1.is_leadership),
          callback: function($$v) {
            _vm.$set(item1, "is_leadership", $$v)
          },
          expression: "item1.is_leadership"
        }
      }, [_c('el-radio', {
        attrs: {
          "label": 1
        }
      }, [_vm._v("指定人\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-radio', {
        attrs: {
          "label": 2
        }
      }, [_vm._v("角色")]), _vm._v(" "), _c('el-radio', {
        attrs: {
          "label": 3
        }
      }, [_vm._v("自选人\n\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', [(item1.is_leadership == 1) ? _c('el-form-item', [_c('el-select', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "filterable": "",
          "clearable": "",
          "multiple": "",
          "collapse-tags": "",
          "placeholder": "请选择指定人"
        },
        model: {
          value: (item1.arr),
          callback: function($$v) {
            _vm.$set(item1, "arr", $$v)
          },
          expression: "item1.arr"
        }
      }, _vm._l((_vm.userList), function(user, userIndex) {
        return _c('el-option', {
          key: userIndex,
          attrs: {
            "label": user.staff_name,
            "value": user.staff_id
          }
        })
      }), 1)], 1) : _vm._e(), _vm._v(" "), (item1.is_leadership == 2) ? _c('el-form-item', [_c('el-select', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "clearable": "",
          "multiple": "",
          "collapse-tags": "",
          "placeholder": "请选择角色"
        },
        model: {
          value: (item1.brr),
          callback: function($$v) {
            _vm.$set(item1, "brr", $$v)
          },
          expression: "item1.brr"
        }
      }, _vm._l((_vm.roleList), function(role) {
        return _c('el-option', {
          key: role.id,
          attrs: {
            "label": role.role_name,
            "value": role.id
          }
        })
      }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "infor-right"
      }, [_c('div', {
        staticClass: "infor-title"
      }, [_vm._v("审批条件")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin": "0 40px"
        }
      }, [_c('el-select', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "placeholder": "请选择集成字段"
        },
        on: {
          "change": function($event) {
            return _vm.changeList(index, index1, $event)
          }
        },
        model: {
          value: (item1.approval_condition_type),
          callback: function($$v) {
            _vm.$set(item1, "approval_condition_type", $$v)
          },
          expression: "item1.approval_condition_type"
        }
      }, _vm._l((_vm.approvalTypeList), function(approvalType) {
        return _c('el-option', {
          key: approvalType.id,
          attrs: {
            "label": approvalType.fieldName,
            "value": approvalType.id
          }
        })
      }), 1)], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin": "24px 40px"
        }
      }, [_c('el-radio-group', {
        model: {
          value: (item1.approval_criteria),
          callback: function($$v) {
            _vm.$set(item1, "approval_criteria", $$v)
          },
          expression: "item1.approval_criteria"
        }
      }, [_c('el-radio', {
        attrs: {
          "label": 1 + ''
        }
      }, [_vm._v("大于")]), _vm._v(" "), _c('el-radio', {
        attrs: {
          "label": 2 + ''
        }
      }, [_vm._v("小于")]), _vm._v(" "), _c('el-radio', {
        attrs: {
          "label": 3 + ''
        }
      }, [_vm._v("等于")])], 1)], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin": "0 40px"
        }
      }, [_c('el-form-item', [_c('el-cascader', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "placeholder": "请选择选项",
          "options": item1.approvalTypeListTwo,
          "props": {
            checkStrictly: true
          }
        },
        on: {
          "change": _vm.changes
        },
        model: {
          value: (item1.judgment),
          callback: function($$v) {
            _vm.$set(item1, "judgment", $$v)
          },
          expression: "item1.judgment"
        }
      }), _vm._v(" "), _c('el-input', {
        staticStyle: {
          "margin-top": "10px"
        },
        attrs: {
          "type": "textarea",
          "rows": 2,
          "disabled": ""
        },
        model: {
          value: (item1.ranges),
          callback: function($$v) {
            _vm.$set(item1, "ranges", $$v)
          },
          expression: "item1.ranges"
        }
      })], 1)], 1)])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "approve-img"
    }, [_c('img', {
      staticStyle: {
        "width": "273px",
        "height": "170px"
      },
      attrs: {
        "src": require("../../../../src/assets/审批+.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.addTwoClick(index, _vm.index1)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "oa-del",
      attrs: {
        "src": require("../../../assets/oa/del.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.delClick(index)
        }
      }
    })])], 2)])], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex == 0),
      expression: "tabIndex == 0"
    }]
  }, [_c('VFormDesigner', {
    ref: "vfDesigner",
    attrs: {
      "designer-config": _vm.designerConfig,
      "field-list-api": _vm.fieldListApi,
      "banned-widgets": _vm.bannedWidgets
    }
  })], 1)], 1) : _vm._e()])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-362c288c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/oa/set/setAdd.vue
// module id = null
// module chunks = 